<div class="cm-add-item-container">
    <span class="cm-add-item-title">{{ $title() }}</span>
    <ng-content select="[cm-dialog-content]"></ng-content>
    <div class="cm-confirmation-container">
        <button class="cm-button cm-cancel" mat-dialog-close [disabled]="$isLoading()">Cancel</button>
        <button class="cm-button cm-confirm" (click)="confirm.emit()" [disabled]="$confirmDisabled() || $isLoading()">{{ $confirmButtonText() }}</button>
    </div>
    @if ($isLoading()) {
        <cm-loading-spinner>
            <ng-container cm-text-bottom>
                <span class="cm-loading-text">Creating new item...</span>
            </ng-container>
        </cm-loading-spinner>
    }
</div>
